import { Metrics } from 'services/hooks/revenue';
import { formatDate } from 'utils/date';

import { getFormatTypeByPeriod } from './getFormatTypeByPeriod';
import { MetricPeriod } from '../hooks/useRevenueMetricsContext';

export function transformForRevenueChart(metrics: Metrics[], period: MetricPeriod) {
  switch (period) {
    case MetricPeriod.ONE_DAY:
    case MetricPeriod.ONE_MONTH: {
      return metrics
        .sort((a, b) => new Date(a.metricDatetime).getTime() - new Date(b.metricDatetime).getTime())
        .map((value) => ({ ...value, metricDatetime: value.metricDatetime }))
        .map((value) => ({
          ...value,
          value: value.preTaxAmount,
          valueGlobal: value.preTaxAmountGlobal,
          name: formatDate(value.metricDatetime, getFormatTypeByPeriod(period)),
        }));
    }
    case MetricPeriod.ONE_WEEK: {
      // 주별 수익금의 경우, 매주 일요일로 노출되도록 하는 것이 현재 정책 (24.12.27)
      return metrics
        .sort((a, b) => new Date(a.metricDatetime).getTime() - new Date(b.metricDatetime).getTime())
        .map((value) => ({ ...value, metricDatetime: value.metricDatetime }))
        .map((value) => ({
          ...value,
          value: value.preTaxAmount,
          valueGlobal: value.preTaxAmountGlobal,
          name: `~${formatDate(value.metricDatetime, getFormatTypeByPeriod(period))}`, // 주별 데이터에 ~를 넣어주는 것이 현재 정책(2025.01.15 기준)
        }));
    }
  }
}
